import React from "react";
import { useAuth } from "../../contexts/AuthContext";
import UserList from "./UserList";
import Sidebar from "../Navigations/Sidebar";
import SelectedBusiness from "../Shared/SelectedBusiness";
import usePageTitle from "../../hooks/usePageTitle";

const UserSetup: React.FC = () => {
  const { user } = useAuth();

  usePageTitle("Users Setup");

  return (
    <div className="app-layout">
      <Sidebar currentPage="/user-setup" />
      <div className="main-content">
        <div className="page-header">
          <h2>👥 Users Setup</h2>
          <p>Manage users for business {user?.SelectedBusiness?.name}</p>
          {/*<SelectedBusiness business={user?.SelectedBusiness} />*/}
        </div>

        <UserList businessId={user?.SelectedBusiness?.id || ""} />
      </div>
    </div>
  );
};

export default UserSetup;
